var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"mr-2",attrs:{"color":_vm.color,"size":_vm.size}},[_c('h5',{class:_vm.fontSize},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }